import { render, staticRenderFns } from "./FormSteps.component.vue?vue&type=template&id=2280465d&scoped=true"
import script from "./FormSteps.component.vue?vue&type=script&lang=js"
export * from "./FormSteps.component.vue?vue&type=script&lang=js"
import style0 from "./FormSteps.component.vue?vue&type=style&index=0&id=2280465d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280465d",
  null
  
)

export default component.exports